import { mutatorAction } from "satcheljs";
import categoryStore from "../store/store";

/**
 * Sets the move to find text in the categoryMenu store
 * @param findText the find text
 */
const setCategoryMenuFindTextMutator: (findText: string) => void = mutatorAction("setCategoryMenuFindText", function setCategoryMenuFindText(findText: string): void {
    categoryStore().categoryMenuViewState.findText = findText;
});
export default setCategoryMenuFindTextMutator;
